export default "__VITE_ASSET__BQ1jx8Ky__"